/**
 * Acquisition Tax Rates by City (Grunderwerbsteuer-Sätze nach Stadt)
 * 
 * These rates are used to calculate acquisition tax on property purchases per city.
 * The values represent the tax rate percentage per city in Germany.
 * 
 * Data structure is designed to be easily migrated to a database table.
 */

export interface AcquisitionTaxRateByCity {
  city: string;
  state: string;
  taxRate: number;
}

export const ACQUISITION_TAX_RATES_BY_CITY: AcquisitionTaxRateByCity[] = [
  // Baden-Württemberg (5,0%)
  { city: 'Stuttgart', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Mannheim', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Karlsruhe', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Freiburg', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Heilbronn', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Ulm', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Pforzheim', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Reutlingen', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Tübingen', state: 'Baden-Württemberg', taxRate: 5.0 },
  { city: 'Ludwigsburg', state: 'Baden-Württemberg', taxRate: 5.0 },

  // Bayern (3,5%)
  { city: 'München', state: 'Bayern', taxRate: 3.5 },
  { city: 'Nürnberg', state: 'Bayern', taxRate: 3.5 },
  { city: 'Augsburg', state: 'Bayern', taxRate: 3.5 },
  { city: 'Regensburg', state: 'Bayern', taxRate: 3.5 },
  { city: 'Ingolstadt', state: 'Bayern', taxRate: 3.5 },
  { city: 'Würzburg', state: 'Bayern', taxRate: 3.5 },
  { city: 'Fürth', state: 'Bayern', taxRate: 3.5 },
  { city: 'Erlangen', state: 'Bayern', taxRate: 3.5 },
  { city: 'Bamberg', state: 'Bayern', taxRate: 3.5 },
  { city: 'Rosenheim', state: 'Bayern', taxRate: 3.5 },

  // Berlin (6,0%)
  { city: 'Berlin', state: 'Berlin', taxRate: 6.0 },
  { city: 'Berlin-Mitte', state: 'Berlin', taxRate: 6.0 },
  { city: 'Berlin-Charlottenburg', state: 'Berlin', taxRate: 6.0 },
  { city: 'Berlin-Kreuzberg', state: 'Berlin', taxRate: 6.0 },
  { city: 'Berlin-Friedrichshain', state: 'Berlin', taxRate: 6.0 },

  // Brandenburg (6,5%)
  { city: 'Potsdam', state: 'Brandenburg', taxRate: 6.5 },
  { city: 'Frankfurt an der Oder', state: 'Brandenburg', taxRate: 6.5 },
  { city: 'Cottbus', state: 'Brandenburg', taxRate: 6.5 },
  { city: 'Brandenburg an der Havel', state: 'Brandenburg', taxRate: 6.5 },
  { city: 'Schönefeld', state: 'Brandenburg', taxRate: 6.5 },

  // Bremen (5,0%)
  { city: 'Bremen', state: 'Bremen', taxRate: 5.0 },
  { city: 'Bremerhaven', state: 'Bremen', taxRate: 5.0 },

  // Hamburg (5,5%)
  { city: 'Hamburg', state: 'Hamburg', taxRate: 5.5 },

  // Hessen (6,0%)
  { city: 'Frankfurt am Main', state: 'Hessen', taxRate: 6.0 },
  { city: 'Wiesbaden', state: 'Hessen', taxRate: 6.0 },
  { city: 'Darmstadt', state: 'Hessen', taxRate: 6.0 },
  { city: 'Kassel', state: 'Hessen', taxRate: 6.0 },
  { city: 'Offenbach', state: 'Hessen', taxRate: 6.0 },

  // Mecklenburg-Vorpommern (6,0%)
  { city: 'Rostock', state: 'Mecklenburg-Vorpommern', taxRate: 6.0 },
  { city: 'Schwerin', state: 'Mecklenburg-Vorpommern', taxRate: 6.0 },
  { city: 'Greifswald', state: 'Mecklenburg-Vorpommern', taxRate: 6.0 },

  // Niedersachsen (5,0%)
  { city: 'Hannover', state: 'Niedersachsen', taxRate: 5.0 },
  { city: 'Braunschweig', state: 'Niedersachsen', taxRate: 5.0 },
  { city: 'Göttingen', state: 'Niedersachsen', taxRate: 5.0 },
  { city: 'Osnabrück', state: 'Niedersachsen', taxRate: 5.0 },
  { city: 'Oldenburg', state: 'Niedersachsen', taxRate: 5.0 },

  // Nordrhein-Westfalen (6,5%)
  { city: 'Köln', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Düsseldorf', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Dortmund', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Essen', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Duisburg', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Bochum', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Wuppertal', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Bielefeld', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Bonn', state: 'Nordrhein-Westfalen', taxRate: 6.5 },
  { city: 'Münster', state: 'Nordrhein-Westfalen', taxRate: 6.5 },

  // Rheinland-Pfalz (5,0%)
  { city: 'Mainz', state: 'Rheinland-Pfalz', taxRate: 5.0 },
  { city: 'Ludwigshafen', state: 'Rheinland-Pfalz', taxRate: 5.0 },
  { city: 'Koblenz', state: 'Rheinland-Pfalz', taxRate: 5.0 },
  { city: 'Trier', state: 'Rheinland-Pfalz', taxRate: 5.0 },

  // Saarland (6,5%)
  { city: 'Saarbrücken', state: 'Saarland', taxRate: 6.5 },

  // Sachsen (5,5%)
  { city: 'Dresden', state: 'Sachsen', taxRate: 5.5 },
  { city: 'Leipzig', state: 'Sachsen', taxRate: 5.5 },
  { city: 'Chemnitz', state: 'Sachsen', taxRate: 5.5 },
  { city: 'Zwickau', state: 'Sachsen', taxRate: 5.5 },

  // Sachsen-Anhalt (5,0%)
  { city: 'Magdeburg', state: 'Sachsen-Anhalt', taxRate: 5.0 },
  { city: 'Halle', state: 'Sachsen-Anhalt', taxRate: 5.0 },
  { city: 'Dessau-Roßlau', state: 'Sachsen-Anhalt', taxRate: 5.0 },

  // Schleswig-Holstein (6,5%)
  { city: 'Kiel', state: 'Schleswig-Holstein', taxRate: 6.5 },
  { city: 'Lübeck', state: 'Schleswig-Holstein', taxRate: 6.5 },
  { city: 'Norderstedt', state: 'Schleswig-Holstein', taxRate: 6.5 },

  // Thüringen (5,0%)
  { city: 'Erfurt', state: 'Thüringen', taxRate: 5.0 },
  { city: 'Jena', state: 'Thüringen', taxRate: 5.0 },
  { city: 'Gera', state: 'Thüringen', taxRate: 5.0 },
  { city: 'Weimar', state: 'Thüringen', taxRate: 5.0 },
];
